import React from 'react';
import { StreamChat } from 'stream-chat';
import {
  Chat,
  Channel,
  MessageInput,
  VirtualizedMessageList,
  Thread,
  Window,
  Streami18n,
} from 'stream-chat-react';
import 'stream-chat-react/dist/css/index.css';
import './App.css';
import { CustomMessage } from './components/Customessage';
import { CustomMessageInput } from './components/sendmessage/sendMessage';
import { PinnedMessageList  } from './components/PinnedMessageList/PinnedMessageList';


const urlParams = new URLSearchParams(window.location.search);
const apiKey = urlParams.get('api_key');
const userId = urlParams.get('user_id');
const channelId = urlParams.get('channel_id');
const theme = urlParams.get('theme') || 'light';
const userToken = urlParams.get('user_token');
const lang = urlParams.get('lang') ? urlParams.get('lang') : 'en';
const i18n = new Streami18n({ language: lang });
const chatClient = StreamChat.getInstance(apiKey);

chatClient.connectUser({ id: userId }, userToken);

const channel = chatClient.channel('messaging', channelId, {});


channel.getConfig = () => ({
  mutes: true,
});


const App = () => (
  <Chat client={chatClient} theme={`messaging ${theme}`} i18nInstance={i18n}>
    <Channel channel={channel} Input={CustomMessageInput}>
    <PinnedMessageList chatClient={chatClient} channelId={channelId}/>

      <Window>
      <VirtualizedMessageList  Message={CustomMessage} scrollToLatestMessageOnFocus={true} defaultItemHeight={76} />
        <MessageInput />
      </Window>

    </Channel>
  </Chat>
);

export default App;
